import get from 'lodash/get';
import IconButton from '@material-ui/core/IconButton';
import React, {useState} from 'react';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {InputAdornment} from '@material-ui/core';
import {Person as PersonIcon} from '@material-ui/icons';
import {unwrapResult} from '@reduxjs/toolkit';
import {useDispatch} from 'react-redux';
import {useFormik} from 'formik';
import * as Yup from 'yup';

import setAuthorizationToken from 'utils/setAuthorizationToken';
import {fetchAuthLogIn, setProfile, setSetting} from 'store/user.slice';
import {PrimaryButton} from '../../Shared/Button';
import {setAnnouncement} from 'store/announcement.slice';

const initialValues = {username: '', password: ''};

const schema = Yup.object().shape({
  username: Yup.string().max(32).required('กรุณากรอกชื่อผู้ใช้ครับ'),
  password: Yup.string().max(32).required('กรุณากรอกรหัสผ่านครับ'),
});

const VipLoginForm = () => {
  const dispatch = useDispatch();

  const [isShow, setIsShow] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async values => {
    dispatch(fetchAuthLogIn(values))
      .then(unwrapResult)
      .then(originalPromiseResult => {
        if (!originalPromiseResult.success) {
          setError(originalPromiseResult.message);
          return;
        }

        dispatch({type: 'LoginSuccess', payload: originalPromiseResult});

        const token = get(originalPromiseResult, 'token');
        const user = get(originalPromiseResult, 'user');

        if (token && user) {
          setAuthorizationToken(token, user);
          dispatch(setProfile(user));
        }

        if (originalPromiseResult?.setting) {
          dispatch(setSetting({data: originalPromiseResult.setting}));
        }

        if (originalPromiseResult?.announcement) {
          dispatch(setAnnouncement(originalPromiseResult.announcement));
        }
      })
      .catch(error => {
        if (typeof error.response === 'undefined') {
          setError('ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้');
        }

        /** return integer case 1, 2, 3 */
        if (error.error) {
          setError(error?.message || error.toString());
        }

        // setError(messageMap[error?.message] || error?.toString());
      });
  };

  const {values, handleChange, handleBlur, touched, errors, handleSubmit, isSubmitting} = useFormik({
    initialValues,
    onSubmit,
    validationSchema: schema,
    validateOnChange: false,
  });

  const handleClickShowPassword = () => {
    setIsShow(!isShow);
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <TextField
        autoFocus
        value={values.username}
        error={!!(touched.username && errors.username)}
        helpertext={touched.username && errors.username}
        label="รหัสพนักงาน"
        name="username"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        variant="outlined"
        fullWidth
        disabled={isSubmitting}
        // className={classes.input}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PersonIcon />
            </InputAdornment>
          ),
        }}
      />
      <TextField
        error={!!(touched.password && errors.password)}
        fullWidth
        helpertext={touched.password && errors.password}
        label="รหัสผ่าน"
        name="password"
        onBlur={handleBlur}
        onChange={handleChange}
        type={isShow ? 'text' : 'password'}
        value={values.password}
        variant="outlined"
        disabled={isSubmitting}
        // className={classes.input}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end">
                {isShow ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <div className="text-center text-red-400">{error}</div>
      <div className="text-right">
        <PrimaryButton disabled={isSubmitting} type="submit">
          เข้าสู่ระบบ
        </PrimaryButton>
      </div>
    </form>
  );
};

export default VipLoginForm;
